/* eslint-disable */
export default {
  cancel: 'Cancelar',
  confirm: 'Confirmar',
} as const;

// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"confirm"@#@ @source: @#@"Confirm"@#@
